module.exports = __webpack_public_path__ + "static/media/mail.0125b073.svg";